/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSpeechGetTranscriptionHistory } from "../../funcs/llmSpeechGetTranscriptionHistory.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetSpeechToTextHistoryRequest$inboundSchema,
};

export const tool$llmSpeechGetTranscriptionHistory: ToolDefinition<
  typeof args
> = {
  name: "llm-speech-get-transcription-history",
  description: `Retrieve speech-to-text history item

Returns metadata for a stored transcription.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSpeechGetTranscriptionHistory(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
